import { db } from '@/api/firebase'
import { User } from '../../models'

const userConverter: firebase.firestore.FirestoreDataConverter<User> = {
  toFirestore(user: User): User {
    return user
  },
  fromFirestore(snap, options): User {
    const dbUser = snap.data(options) as User
    dbUser.uid = snap.id
    return User(dbUser)
  }
}

const usersRef = db.collection('users').withConverter(userConverter)
const userRef = (userId: string) => usersRef.doc(userId)

export {
  userRef
}